/**
 * Custom indexes to use when adding control into google map controls.
 */
export const IDX_NETWORK_CONTROL = 11;
export const IDX_BUILDING_MODE_CONTROL = 12; 
export const IDX_DRAWING_CONTROL = 14;
export const IDX_RANGE_CONTROL = 14;